import { environment } from '~env/environment';

export const DIRECT_DEBIT_SVG = () => `${environment.cdnBaseUrl()}/images/sepa-icon.svg`;
export const RATE_PAY_SVG = () => `${environment.cdnBaseUrl()}/images/ratepay_logo.svg`;
export const VISA_SVG = () => `${environment.cdnBaseUrl()}/images/visa_logo.png`;
export const MASTER_CARD_SVG = () => `${environment.cdnBaseUrl()}/images/master_logo.png`;
export const AMERICAN_EXPRESS_SVG = () => `${environment.cdnBaseUrl()}/images/american_express_logo.png`;
export const PAYPAL_SVG = () => `${environment.cdnBaseUrl()}/images/icons/paypal-logo.svg`;
export const PAYPAL_SVG_TEXT = () => `${environment.cdnBaseUrl()}/images/paypal_logo_text.svg`;
export const SOFORT_SVG = () => `${environment.cdnBaseUrl()}/images/icons/klarna-logo.svg`;
export const IDEAL_SVG = () => `${environment.cdnBaseUrl()}/images/icons/ideal-logo-checkout.svg`;
export const CARTES_BANCAIRES_JPG = () => `${environment.cdnBaseUrl()}/images/cartes_bancaires_logo.jpg`;
export const INVOICE = () => `${environment.cdnBaseUrl()}/images/rechnung-icon.svg`;
export const BILLIE = () => `${environment.cdnBaseUrl()}/images/icons/billie-logo.svg`;
